import React from 'react'
import Portada from '../components/portada'

import Portada_Interna from '../components/portada_interna'
import Navbar from '../NavBar'
import Footer from '../components/footer'
import ButtonUp from '../components/buttonUp'
import Gallery from '../components/gallery'
import Incoherencia from '../components/incoherencia'

export default function Escritos() {
  const incoherenciaList = [
    {
      id:'refugio_latinoamericano',
      title:'Refugio Latinoamericano - Redactora',
      phg:'Mi participación como redactora en Refugio Latinoamericano se vincula con la investigación y producción de contenidos sobre migración, cultura, territorio y experiencias comunitarias en América Latina. A través de entrevistas, investigación y escritura, busco construir relatos que den visibilidad a las experiencias de quienes atraviesan procesos de movilidad, desplazamiento y transformación, poniendo en diálogo las dimensiones sociales, culturales y políticas de esas experiencias.',
      links:[
        {label:'Entrevista a Angélica Cid Rubio, de Mariposas Sin Fronteras (Antofagasta, 2026)', href:'https://refugiolatinoamericano.com/entrevista-angelica-cid-rubio-mariposas-sin-fronteras-21062026/'},
        {label:'Festival Internacional Kinissis: cuando la experiencia migrante se vuelve comunidad en movimiento (Santiago de Chile, 2026)', href:'https://refugiolatinoamericano.com/festival-internacional-kinissis-cuando-la-experiencia-migrante-se-vuelve-comunidad-en-movimiento/'},
        {label:'Todas mis publicaciones en Refugio Latinoamericano', href:'https://refugiolatinoamericano.com/author/maria-estevez/'},
      ]
      },
    {
      id:'revista_meer',
      title:'Revista Meer - Redactora',
      phg:'Desde 2023 soy redactora de la revista internacional Meer, donde desarrollo artículos, entrevistas, crónicas y textos de autor vinculados al arte, la cultura, la arquitectura y las problemáticas sociales contemporáneas. Mi escritura se construye desde una mirada interdisciplinaria, atravesada por mi experiencia como abogada, artista y gestora cultural: me interesa explorar las relaciones entre cuerpo, territorio, arquitectura, identidad, migración y memoria.',
      links:[
        {label:'Entrevista a Angélica Cid Rubio, de Mariposas Sin Fronteras', href:'https://www.meer.com/es/110554-entrevista-a-angelica-cid-rubio-de-mariposas-sin-fronteras'},
        {label:'El circo, arte nómade y popular', href:'https://www.meer.com/es/109423-el-circo-arte-nomade-y-popular'},
        {label:'Los estados de la niebla en el desierto de Atacama', href:'https://www.meer.com/es/109877-los-estados-de-la-niebla-en-el-desierto-de-atacama'},
        {label:'Más allá de Ofelia: identidad y percepción', href:'https://www.meer.com/es/103871-mas-alla-de-ofelia-identidad-y-percepcion'},
        {label:'Poética del encuentro multidisciplinario', href:'https://www.meer.com/es/94280-poetica-del-encuentro-multidisciplinario'},
        {label:'El Festival Internacional Kinissis de danza contemporánea', href:'https://www.meer.com/es/102817-el-festival-internacional-kinissis-de-danza-contemporanea'},
        {label:'Arte contemporáneo: arquitectura y danza', href:'https://www.meer.com/es/91789-arte-contemporaneo-arquitectura-y-danza'},
        {label:'Ryue Nishizawa en Ocho Quebradas', href:'https://www.meer.com/es/87328-ryue-nishizawa-en-ocho-quebradas'},
        {label:'“Desiertos: un viaje de perspectivas” en la Casa Curutchet', href:'https://www.meer.com/es/86171-desiertos-un-viaje-de-perspectivas-en-la-casa-curutchet'},
        {label:'La errancia y la búsqueda interior en “Desiertos”', href:'https://www.meer.com/es/83310-la-errancia-y-la-busqueda-interior-en-desiertos'},
        {label:'Doppelgänger digital: la dualidad humana en la era de la IA', href:'https://www.meer.com/es/80979-doppelganger-digital-la-dualidad-humana-en-la-era-de-la-ia'},
        {label:'El espejo', href:'https://www.meer.com/es/100452-el-espejo'},
        {label:'Las partes del todo', href:'https://www.meer.com/es/96159-las-partes-del-todo'},
        {label:'Cuerpos para un ave', href:'https://www.meer.com/es/95864-cuerpos-para-un-ave'},
        {label:'Aves para un cuerpo', href:'https://www.meer.com/es/95766-aves-para-un-cuerpo'},
        {label:'El sobre', href:'https://www.meer.com/es/89432-el-sobre'},
        {label:'Cielo azul', href:'https://www.meer.com/es/82247-cielo-azul'},
        {label:'Maderitas precarias', href:'https://www.meer.com/es/81850-maderitas-precarias'},
        {label:'El eco de los rieles', href:'https://www.meer.com/es/81278-el-eco-de-los-rieles'},
        {label:'Primera parada: jardín nocturno', href:'https://www.meer.com/es/81277-primera-parada-jardin-nocturno'},
        {label:'La petite mort: el éxtasis del amor y la muerte', href:'https://www.meer.com/es/80591-la-petite-mort-el-extasis-del-amor-y-la-muerte'},
        {label:'La sensibilidad de lo fantástico', href:'https://www.meer.com/es/80352-la-sensibilidad-de-lo-fantastico'},
        {label:'Mi libreta de incoherencias', href:'https://www.meer.com/es/79621-mi-libreta-de-incoherencias'},
        {label:'La palabra como experiencia sensible', href:'https://www.meer.com/es/78323-la-palabra-como-experiencia-sensible'},
        {label:'Mi libreta de incoherencias — “Luna invertida” y “Sinuosa”', href:'https://www.meer.com/es/77158-mi-libreta-de-incoherencias'},
        {label:'Mi libreta de incoherencias — “Antídoto para el tercer día” y “Mi línea de flotación”', href:'https://www.meer.com/es/77009-mi-libreta-de-incoherencias'},
        {label:'Mi libreta de incoherencias — “Peces de fuego” y “Caldero del tiempo”', href:'https://www.meer.com/es/76458-mi-libreta-de-incoherencias'},
        {label:'Mary Shelley: anatomía de una pesadilla', href:'https://www.meer.com/es/75169-mary-shelley-anatomia-de-una-pesadilla'},
        {label:'Todos mis artículos en Meer', href:'https://www.meer.com/es/authors/1416-maria-estevez'},
      ]
      },
    {
    id:'uno',
    title:'Día 1 Peces de fuego ',
    phg:'Quedar en blanco y comenzar. El tiempo espanta, la quietud atrae. Encandilada y con miedo anuncio el siguiente paso.  Camino al túnel de peces muertos, peces sin espinas, blandos, mal olientes. De ahí se sale primero por la cabeza, mirando afuera. Luego, como cada uno quiera o pueda. Quedarme también puede ser mi aventura. Recorrer los detalles del túnel. Peces encimados. Enzimas bariátricas para poder comerlos todos y morir indigestada. Peces que mueren incendiados en un mar sin agua. En un mar de fuego. ¿Quiénes viven en los mares de fuego?'
    },
    {
    id:'dos',
    title:'Día 2 El caldero del tiempo',
    phg:'No sé porque?. Ser, saber, sentir. Sentir encerrada sin agujeros. Sentir para adentro. Saber para que. Contar hasta doce y no saltar. Jugar en el espacio aunque sea pequeño. Alguien mira desde abajo, pero no  puede entrar. Alguien mira desde arriba, pero no puede saltar. Y yo miro desde adentro. No me gusta. Pongo punto. Silenciosamente guardo los líquidos mágicos que una vez soñé. Encerrados y exhibidos  en una tienda. Tiendita de saldos. En noches de tormentas, tormentas creativas que despiertan monstruos. '
    },
    {
    id:'tres',
    title:'Día 3 ANTIDOTO PARA EL TERCER DIA',
    phg:'Antídoto para el tercer día. Para no resucitar entre los muertos. Para salir corriendo, entrar en un taxi. Taxi amarillo que interrumpe la infancia. Taxi amarillo que te traerá de vuelta. Subir con una mochila repleta de fórmulas. ¿Secretas? ¿Manifiestas?  ¿Útiles? ¿Basura? Sentirte bifurcada, andar derecho. Hacer lo que busques adentro. Sentirte poderosa. Tener el antídoto. Flechas venenosas que te cortan y te achican. '
    },
    {
    id:'cuatro',
    title:'Día 4 Mi línea de flotación ',
    phg:'La cerca de sol está en la punta de la pradera. Tu cuerpo poderoso te lleva con grandes saltos, inesperados saltos que te sorprenden. Sin darte cuenta te encontrás realizando hazañas acrobáticas que te llevan a un lugar solitario, pasando los bosques, pasando las cascadas, pasando los  lobos asesinos, y  las miradas fulminantes. Una vez ahí no queda más que recostarse en la hierba verde y húmeda bajo la cerca de sol que revelará la verdad de tu piel brillante. Sera la mirada abierta y valiente la que te hará gustarte. Si! Si!  Si, gustar de vos. Gustar de tu monstruo. No es una acción solitaria. Es una acción de revote.'
    },
    {
    id:'cinco',
    title:'Día 5 LUNA INVERTIDA',
    phg:'(Primero nombrada y luego creada)  Nombrada en hoja en blanco. Nacida con título.  Luna invertida. Luna de nadie que vea calzado. Ojos calzados con cuero marrón mojados por la lluvia.  Volvemos a empezar, pero desde otro lado. Invierto el pensar, el arriba llega abajo. Luna invertida. Luna amada. Nombrada, nacida sin cuerpo. Título en blanco. Luna inventada pero firme. Los hechos nos sorprenden. '
    },
    {
    id:'seis',
    title:'Día 6 SINUOSA',
    phg:'Escenografía de  un amor.    Camino sinuosa escapando a los vértices. Paredes de concreto que ofrecen libertad. Contrapisos, contrapasos. Pasos en contra de las riendas. Dejar de esconderme detrás de incoherencias, nombrar las palabras sin excusas, hacerlas propias y de nadie.  Las venas abiertas del tiempo que derraman verdades. Las venas cerradas de los miedos que explotan frustraciones. Temer y aun sostener lo que la gravedad ya desintegró. Que mi incoherencia se transforme en relato, en historia, que acontezca.'
    },
    {
    id:'siete',
    title:'Día 7 Madriguera',
    phg:'Madriguera agreste, confusa, pero mía.  Honda y silente. De barro al comienzo y etérea luego. Quieta por fuera, remolino vital por dentro. Ver lo que gira y sacar la sortija. Tal vez una llave…. Seguro una llave.  Cerrojos abiertos. Lagrimas cayendo, sentir la belleza de lo desconocido de lo no atrapado. Madriguera infinita. Madriguera transporte. Volar cayendo. Pensar saliendo. Pausa preciosa que me permite entender. Y otra vez saberme vulnerable. ¿Cuántas madrigueras hay en un bosque? ¿Es necesario un bosque?  No creo…. Madriguera de pensamientos. '
    },
    {
    id:'ocho',
    title:'Día 8 La Replica',
    phg:'Arrancar para no mostrar. Desojar y dejar la huella. El camino de la creación tiene certezas blandas, que se desmoronan, cambian de forma. ¿De donde agarrarse entonces...? ¿o no agarrarse y resistir?  Andar sin suelo. Romper para que no exista, para empezar de nuevo. Una vez leí que la muerte nunca tiene intensidad cero, algo late siempre. ¿Cuál es el color de nuestros deseos más profundos? ¿Todo va de acuerdo al plan?. No hay plan. No? No, ninguno'
    },
    {
      id:'nueve',
      title:'Día 9 Aire Seco',
      phg:'Perdida, clausurada, encerrada sin salida, dormida. Gritar lo mismo sin sonido. Lagrimas. ¿Es válido preguntarse para avanzar? La eterna búsqueda de sentido.¿Donde está la chispa de la alegría? Pensamientos secretos, solo míos. Pensamientos encerrados. '
      },
  ]

  const linskEscritos = [
    {
      name:"Refugio Latinoamericano",
      href:"#refugio_latinoamericano"
      },
    {
      name:"Revista Meer",
      href:"#revista_meer"
      },
    {
      name:"uno",
      href:"#uno"
      },
    
      {
      name:"dos", 
      href:"#dos"
      },
      {
      name:"tres ", 
      href:"#tres"
      },
    
      {
      name:"cuatro", 
      href:"#cuatro"
      },
      {
      name:"cinco", 
      href:"#cinco"
      }, 
      {
      name:"seis", 
      href:"#seis"
      }, 

      {
      name:"siete", 
      href:"#siete"
      }, 
      {
      name:"ocho", 
      href:"#ocho"
      }, 
      {
        name:"nueve",
        href:"#nueve"
        },

  ]

  return (  
    <div className='flex flex-col w-full h-full '>
       <div className=" z-10 ">
         <Navbar />
       </div>
        <Portada_Interna
        links={linskEscritos}
        title={"Escritos"}
        page={"escritos"}
        img={"/png/portada-escritos.jpg"}
        />

    <ButtonUp/>
      <div className='flex flex-col bg-primary-500 text-secondary-500 gap-32  px-8 lg:px-28 pt-10  pb-20'>
      {incoherenciaList.map((incoherencia)=>{
        return(
        <Incoherencia key={incoherencia.id} id={incoherencia.id} title={incoherencia.title} phg={incoherencia.phg} links={incoherencia.links}/>
        )
      })}

      </div>
      <Footer/>
    </div>
  )
}
